<template>
  <div class="chatContainer">
    <div class="messagebox history" :class="props.showTabs ? 'showTabBar' : 'hideTabBar'">
      <a-tabs
        v-model:activeKey="activeKey"
        style="width: 100%; height: 660px"
        class="messagebox-tabs"
      >
        <a-tab-pane v-for="c in chatInfoGroupTabs" :key="c.groupId" :forceRender="props.showTabs">
          <template #tab>
            <span class="tabTitle">{{ c.title }}</span>
          </template>
          <WechatPatientChat
            v-if="c.groupId === weComPatientChatId"
            :active="activeKey === weComPatientChatId"
            :doctorId="props.ucDoctorId"
            :patientId="weComPatientId"
            :workOrderId="props.workOrderId"
            :eligibility="weComEligibility"
            readonly
            :polling="false"
          />
          <div
            v-else
            style="padding-bottom: 50px"
            :ref="setMessageboxRef(c.groupId)"
            :class="['messagebox-content', props.showTabs ? 'onlyHistroy' : 'no-tabs-history']"
          >
            <div class="more-message" v-if="messageMap[c.groupId]?.length > 0 && showLoadMore">
              <div class="getMoreMsg" v-if="newMsgTipsMap[c.groupId]?.loadText">
                <auth-img @click="loadMoreMsgs" :src="getMoreMsg" alt="" />
                <a @click="loadMoreMsgs" v-if="newMsgTipsMap[c.groupId]?.loadText">
                  {{ newMsgTipsMap[c.groupId]?.loadText }}
                </a>
                <a-input
                  v-model:value="newMsgTipsMap[c.groupId].pageSize"
                  style="width: 45px; border-radius: 4px"
                  size="small"
                  @pressEnter="loadMoreMsgs"
                />
                <span>条</span>
              </div>
              <div class="getMoreMsg rightAction">
                <a v-if="!newMsgTipsMap[c.groupId]?.isScrollTop" @click="scrollTop">
                  <auth-img :src="toTop" alt="" />
                  回到顶部
                </a>
                <a v-if="!newMsgTipsMap[c.groupId]?.isScrollBottom" @click="scrollBottom">
                  <auth-img :src="toBottom" alt="" />
                  返回底部
                </a>
              </div>
            </div>
            <div v-if="newMsgTipsMap[c.groupId]?.showLoading">
              <a-spin />
            </div>
            <div
              @click="chooseUnderMessage"
              :ref="setChooseRef(c.groupId)"
              v-if="props.showCheckbox"
              class="choose-under-message"
            >
              <span>点击选择以下消息</span>
            </div>
            <div v-if="props.msgTimeRange" class="time-style message-time-range">
              <span>{{ msgTimeRange }}</span>
            </div>
            <div
              class="message-list"
              :ref="setMessageListRef(c.groupId)"
              v-if="messageMap[c.groupId]?.length > 0"
            >
              <div
                v-for="(item, index) in messageMap[c.groupId]"
                :key="item.msgId"
                class="message-group"
                :id="item.msgId"
                :data-index="index"
                :data-canchecked="item.bodies.type !== 'custom' ? 1 : 0"
              >
                <!-- 消息时间 -->
                <div
                  v-if="
                    !Config.SHIELD_MSG.includes(`${item.msgType}`) &&
                    (index === 0 ||
                      getTimeVisible(
                        (messageMap[c.groupId] && messageMap[c.groupId][index - 1]) || {},
                        item
                      ))
                  "
                  class="time-style"
                >
                  {{ formatTime(item.timestamp) }}
                </div>
                <!-- 撤回消息 -->
                <div v-if="item.msgStatus === -1" class="more-message">
                  <!-- 判断 撤回的AI消息 -->
                  <div v-if="item.msgType === 50800" class="more-text">
                    {{ renderRecalByAI(item) }}
                  </div>
                  <!-- 判断 撤回的AI小结消息 -->
                  <div v-else-if="item.msgType === 29005" class="more-text">
                    {{ renderRecalByAI(item) }}
                  </div>
                  <div v-else class="more-text">{{ renderRecal(item) }}</div>
                </div>
                <!-- 复诊提醒 -->
                <RemindCard
                  v-else-if="item.msgType === 50550"
                  title="医生已为患者设置复诊提醒"
                  :content="getRemindContent(item.bodies)"
                ></RemindCard>
                <!-- 视频咨询结束卡片 -->
                <picVideoConsult v-else-if="item.msgType === 50900" :msg="item.bodies" />
                <!-- 图文咨询卡片 -->
                <picTextConsult v-else-if="item.msgType === 50020" :msg="item.bodies" />
                <!-- 问卷结果卡片 -->
                <div class="card" v-else-if="item.msgType === 23020">
                  <ScaleResults :msg="item.bodies"></ScaleResults>
                </div>
                <!-- 医生打招呼特殊处理 -->
                <Tips v-else-if="item.msgType === 50001" :title="item.bodies.toPatient" />
                <!-- 导诊绑定医生和医生助手 -->
                <Tips v-else-if="[25009, 25010].includes(item.msgType)" :title="item.bodies.toDa">
                  <template #addlink>
                    <span
                      style="color: #1890ff; cursor: pointer; padding: 0 0"
                      @click="
                        seeBindDetail(item.bodies, item.msgType === 25009 ? 'doctor' : 'assistant')
                      "
                    >
                      {{ item.bodies.toDaLinkMsg }}>>
                    </span>
                  </template>
                </Tips>
                <Tips
                  v-else-if="Config.SYSTEM_MESSAGES.includes(`${item.msgType}`)"
                  :title="item.bodies.toDa"
                />
                <!-- 区分是否购买服务包 -->
                <Tips
                  v-else-if="item.msgType === 25001"
                  :title="
                    item.bodies.msgTypeDesc === 'service_pack'
                      ? '由于患者购买了服务包，本次问诊为0元'
                      : '患者和医生的问诊已经建立，请根据实际情况做好您的服务'
                  "
                />
                <!-- 医生评价卡片 -->
                <EvalutionToDoctor
                  v-else-if="item.msgType === 29001"
                  :info="item"
                  :doctorName="doctorName"
                  :canRate="false"
                />
                <!-- 推荐药品卡片 -->
                <ReMedicines :msg="item.bodies" v-else-if="item.msgType === 50802"></ReMedicines>
                <!-- 购药卡片 -->
                <DrugBuyCard :msg="item.bodies" v-else-if="item.msgType === 52000"></DrugBuyCard>
                <!-- 健管评价卡片 29401 待评价 29402 已评价-->
                <EvalutionToHelper
                  v-else-if="[29401, 29402].includes(item.msgType)"
                  :evaluteConfig="item"
                />
                <!-- 取消问诊订单系统提示 -->
                <template v-else-if="item.msgType === 24004">
                  <Tips title="患者发起的问诊还未支付"></Tips>
                </template>
                <template v-else-if="item.msgType === 25003">
                  <Tips :title="item.bodies.toDa || '当前问诊已结束'"></Tips>
                </template>
                <!-- 系统消息 -->
                <Tips
                  v-else-if="
                    !Config.SHIELD_MSG.includes(`${item.msgType}`) &&
                    tipsMessageType.includes(`${item.msgType}`)
                  "
                  :title="sysTitle(item)"
                >
                  <!-- :title="Config.TIPS_MESSAGE_TYPE[`${item.msgType}`]" -->
                  <template #addlink v-if="item.msgType === 22006">
                    <span
                      style="color: #1890ff; cursor: pointer; padding: 0 0"
                      @click="
                        toDetail(
                          item.bodies.oldRecommendId,
                          item.msgType,
                          item.bodies?.parentInstanceSn
                        )
                      "
                    >
                      处方ID：{{ item.bodies.oldRecommendId }}
                    </span>
                  </template>
                </Tips>
                <!-- 卡片消息 -->
                <div
                  v-else-if="!Config.SHIELD_MSG.includes(`${item.msgType}`)"
                  class="message-box"
                  :class="{ bySelf: item.from === chatId }"
                >
                  <div
                    @click="checkboxChange(item, index)"
                    class="fixed-checkbox-cover"
                    v-if="props.showCheckbox && item.bodies.type !== 'custom'"
                  ></div>
                  <a-checkbox
                    :style="{
                      visibility: item.bodies.type !== 'custom' ? '' : 'hidden'
                    }"
                    v-model:checked="item.checked"
                    v-if="props.showCheckbox"
                    @change="checkboxChange(item, index)"
                    class="checkbox-container"
                  ></a-checkbox>
                  <!-- 发送人信息 -->
                  <div class="header">
                    <!-- 50702 更年期健康项目 以团长名义推送文字消息  -->
                    <auth-img
                      mode="ant"
                      :width="44"
                      :height="44"
                      :src="
                        item.msgType === 50702
                          ? item.bodies.teamLeaderHeadUrl
                          : renderHeader(item.from)
                      "
                      :fallback="renderDefaultHeader(item.from)"
                    />
                  </div>
                  <div class="message-main">
                    <div class="user-name" :class="{ isSelf: item.from === chatId }">
                      <div
                        :style="
                          item.msgType === 50702
                            ? { backgroundColor: '#D6EAFF', color: '#1890FF' }
                            : renderClass(item.from)
                        "
                        class="user-title"
                      >
                        {{ item.msgType === 50702 ? '医生' : renderTitle(item.from) }}
                      </div>
                      <span>
                        {{
                          item.msgType === 50702
                            ? item.bodies.teamLeaderName
                            : renderName(item.from)
                        }}
                      </span>
                    </div>
                    <!-- 消息主体 -->
                    <div class="message-content">
                      <!-- 群聊消息已读未读人员列表 -->
                      <div
                        :class="{
                          other_read_flag: item.from !== chatId,
                          self_read_flag: item.from === chatId
                        }"
                        v-if="isOpenAck && item.msgRecipients"
                      >
                        <div
                          v-if="
                            handleAckReadStatus(item).type === 'img' &&
                            handleAckReadStatus(item).num === 0
                          "
                        >
                          <auth-img
                            :preview="false"
                            :width="16"
                            :height="16"
                            :src="handleAckReadStatus(item).res"
                          />
                        </div>
                        <a-popover
                          v-else
                          trigger="click"
                          overlayClassName="readStatus-popover"
                          :placement="item.bySelf ? 'topRight' : 'topLeft'"
                        >
                          <template #title>
                            <div class="readPop">已读人员</div>
                          </template>
                          <template #content>
                            <div
                              class="reader"
                              v-for="(item, index) in hadnleReadRoles(item)"
                              :key="index"
                            >
                              {{ item }}
                            </div>
                          </template>
                          <span v-if="handleAckReadStatus(item).type === 'img'">
                            <auth-img
                              :preview="false"
                              :width="16"
                              :height="16"
                              :src="handleAckReadStatus(item).res"
                            />
                          </span>
                          <div v-else class="flag_num">
                            {{ handleAckReadStatus(item).res }}
                          </div>
                        </a-popover>
                      </div>
                      <!-- 图片消息 -->
                      <div v-if="item.bodies.type === 'img'" class="message-img-box">
                        <auth-img
                          mode="ant"
                          @click="setPreviewImgId(item)"
                          :width="200"
                          :height="200"
                          :src="handleImg(item.bodies.url)"
                          fallback="data:image/png;base64,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"
                          :preview="false"
                        />
                      </div>
                      <!-- 音频消息 -->
                      <div v-else-if="item.bodies.type === 'audio'" style="height: auto">
                        <auth-img
                          mode="audio"
                          :src="item.bodies.url"
                          style="background: none"
                          controls
                          menu
                        ></auth-img>
                      </div>
                      <!-- 视频消息 -->
                      <div v-else-if="item.bodies.type === 'video'">
                        <auth-img
                          mode="video"
                          :src="item.bodies.url"
                          width="200"
                          controls
                        ></auth-img>
                      </div>
                      <!-- 聊天消息 -->
                      <p
                        v-else-if="item.bodies.type === 'txt'"
                        v-html="renderTxt(item.bodies.msg)"
                      ></p>
                      <!-- 需要使用html展示，并且是气泡展示 -->
                      <div v-else-if="Config.HTML_MESSAGES.includes(`${item.msgType}`)">
                        <FirstBindingDoctor
                          v-if="[50500, 50503].includes(item.msgType)"
                          :msg="item.bodies"
                          :customEvent="item.msgType"
                          :doctorName="doctorName"
                        />
                        <!-- 新版五要素-->
                        <FiveElements
                          v-else-if="[53001].includes(item.msgType)"
                          :msg="item?.bodies"
                          :customEvent="item.msgType"
                          :doctorName="doctorName"
                        />
                        <div v-else v-html="item.bodies.msg"></div>
                      </div>
                      <div class="aiMsgs" v-else-if="[50501].includes(item.msgType)">
                        {{ item.bodies.question }}
                      </div>
                      <Card
                        :isBySelf="item.bySelf"
                        v-else-if="item.bodies.type === 'custom' && item.msgType !== 50702"
                        :msgObject="{ ...item.bodies, customEvent: `${item.msgType}` } || {}"
                        :msgBody="item"
                        :customEvent="`${item.msgType}`"
                      />
                      <p
                        v-if="item.bodies.type === 'custom' && item.msgType === 50702"
                        v-html="renderTxt(item.bodies.msgContent)"
                      ></p>
                      <div v-if="item.msgType === 50702">
                        <div class="message-bottom-tips">
                          引用：
                          <span
                            v-for="(snItem, snIndex) in prescriptionSnList(
                              item.bodies?.prescriptionSn
                            )"
                            class="message-tips-text"
                            :key="snItem"
                            @click="() => handleTreatmentPlan(snItem)"
                          >
                            {{
                              `${
                                prescriptionSnList(item.bodies?.prescriptionSn)?.length > 1
                                  ? `治疗方案${snIndex + 1}`
                                  : '治疗方案'
                              }${
                                prescriptionSnList(item.bodies?.prescriptionSn)?.length ===
                                snIndex + 1
                                  ? ''
                                  : '，'
                              }`
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="empty-box">
              <auth-img class="empty-img" src="@/assets/img/empty.png" alt="缺损" />
              <div class="empty-text">暂无消息</div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <!-- 线下处方弹窗 -->
    <the-detail
      v-model:visible="theDetailVisible"
      :id="prescriptionId"
      :serialNumber="serialNumber && serialNumber.length === 1 ? '' : serialNumber"
      :recordType="recordType"
    />

    <!-- 图片预览组件 -->
    <ImageViewer
      :visible="imageViewerVisible"
      :imageList="srcList"
      :currentId="previewImgId"
      @setVisible="setimageViewerVisible"
    />
    <!-- 绑定医生详情 -->
    <BindDetailInfo
      ref="bindDetailInfoRef"
      v-bind="$attrs"
      :activeGroupKey="activeKey"
      :isPatChat="activeKey === privateId"
      :isHistorySession="true"
    />
    <!-- 专属医生助手 -->
    <BindAssistent ref="bindAssistentRef" />
  </div>
</template>

<script setup>
import Config from '@/config/index'
import Tips from './components/message/tips.vue'
import Card from './components/message/card.vue'
import RemindCard from './components/message/remindCard.vue'
import FirstBindingDoctor from './components/FirstBindingDoctor/index.vue'
import {
  watch,
  ref,
  reactive,
  defineProps,
  nextTick,
  defineEmits,
  computed,
  watchEffect
} from 'vue'
import ScaleResults from './components/ScaleResults/index.vue'
import EvalutionToDoctor from './components/message/evalutionToDoctor.vue'
import EvalutionToHelper from './components/message/evalutionToHelper.vue'
import { getHistoryByAssistant } from '@/api/chat'
import { formatTime, handleRole, renderClass, renderTitle, handleImg } from '@/utils/index'
import head_z from '@/assets/img/chat/head_z.png'
import head_d from '@/assets/img/chat/head_d.png'
import head_p from '@/assets/img/chat/head_p.png'
import head_a from '@/assets/img/chat/head_a.png'
import head_h from '@/assets/img/chat/head_h.png'
import head_ai from '@/assets/img/chat/head_ai.png'
import { useStore } from 'vuex'
import { groupInfos, getMsgIndex, getGroupImgMsgUrls } from '@/api/chat'
import { notification } from 'ant-design-vue'
import { subStringToType } from '@/utils/index'
import TheDetail from '@/components/TheDetail/index.vue'
import ImageViewer from './components/ImageViewer/index.vue'
import BindDetailInfo from './components/bindDetailInfo/index.vue'
import BindAssistent from './components/bindAssistent/index.vue'
import picTextConsult from './components/message/picTextConsult.vue'
import picVideoConsult from './components/message/picVideoConsult.vue'
import ReMedicines from './components/message/ReMedicines/index.vue'
import DrugBuyCard from './components/message/DrugBuyCard/index.vue'

import moment from 'moment'
import { useReadStatus, useCommonWords, useChatInfoGroup, useChatAction } from './hooks'
import { message as Message } from 'ant-design-vue'
import FiveElements from '@/views/WorkPlace/Container/chat/components/FiveElements/index.vue'
import WechatPatientChat from './components/WechatPatientChat/index.vue'
import useWechatPatientEligibility from './hooks/useWechatPatientEligibility'
const { replaceEmojiCodesWithImages } = useCommonWords()

const store = useStore()
const { handleAckReadStatus } = useReadStatus()
const isOpenAck = computed(() => store.state.user.isOpenReadAck)
const hadnleReadRoles = ctxMsg => {
  const { readers = [] } = ctxMsg
  const res = []
  readers.forEach(item => {
    let roles = ''
    const first = item.emUserId ? item.emUserId.substr(0, 1) : ''
    if (first === 'p') {
      roles = '患者'
    } else if (first === 'a') {
      roles = 'BD'
    } else if (first === 'z') {
      roles = '医生助手'
    } else if (first === 'h') {
      roles = '合作医助'
    } else {
      roles = '医生'
    }
    res.push(`${roles}-${item.userName}`)
  })
  return res
}
const {
  activeKey,
  messageMap,
  chatInfoGroupTabs,
  messageboxRefs,
  newMsgTipsMap,
  messageListRefs,
  setMessageboxRef,
  setMessageListRef,
  generateConversationList,
  weComPatientChatId,
  setWeComPatientChatVisible
} = useChatInfoGroup()
const {
  eligibility: weComEligibility,
  checkEligibility: checkWeComEligibility,
  resetEligibility: resetWeComEligibility
} = useWechatPatientEligibility()
const { scrollBottom, scrollTop, getScrollHeight, getMoreMsg, toTop, toBottom } = useChatAction(
  messageMap,
  newMsgTipsMap,
  messageboxRefs,
  activeKey
)
const props = defineProps({
  // 是否根据msgId跳到某条消息
  msgTraceId: {
    type: [Number, null],
    default: null
  },
  groupId: {
    type: String,
    default: ''
  },
  privateId: {
    type: String,
    default: ''
  },
  guideConsultGroupId: {
    type: String,
    default: ''
  },
  showTabs: {
    type: Boolean,
    default: true
  },
  showCheckbox: {
    type: Boolean,
    default: false
  },
  // 这个字段切不可传错
  customList: {
    type: Array,
    default: () => []
  },
  showLoadMore: {
    type: Boolean,
    default: true
  },
  selectHistoryList: {
    type: Array,
    default: () => []
  },
  maxCheckedLength: {
    type: Number,
    default: 99
  },
  msgTimeRange: {
    type: String,
    default: ''
  },
  doctorDaGroupId: {
    // 医生私聊群
    type: String,
    default: ''
  },
  ucDoctorId: { type: [String, Number], default: '' },
  ucPatientId: { type: [String, Number], default: '' },
  ucUserId: { type: [String, Number], default: '' },
  workOrderId: { type: [String, Number], default: '' }
})
const weComPatientId = computed(() => props.ucPatientId || props.ucUserId)
const emit = defineEmits(['checkboxChange'])
//系统消息对应文本
const tipsMessageType = Object.keys(Config.TIPS_MESSAGE_TYPE) || []
//群组信息暂存
const deepWorkOrderGroupInfo = reactive({})
//线下处方详情弹窗
const theDetailVisible = ref(false)
//线下处方观察处方笺号
// const { serialNumber = '' } = workInfo
const serialNumber = ref('')
//西药 中药 辅助方
// const prescriptionVisible = ref(false)
const recordType = ref('')
const prescriptionId = ref(-1)
const imageViewerVisible = ref(false) // 图片预览是否可见
//正在预览的图片消息id
const previewImgId = ref('')
const srcList = ref([]) // 预览图片列表
//工单Id
const chatId = store.getters.chatId
const doctorName = ref('')
const checkedMsgList = computed(() => {
  return messageMap[activeKey.value].filter(msg => msg.checked)
})
const prescriptionSnList = str => {
  const resultArray = str.split(',').map(item => item.trim())
  return resultArray
}
// 点击续方ID，跳转至处方详情
//parentInstanceSn 联合处方编号。新的续方消息返回
const toDetail = (recommandId, customEvent, parentInstanceSn) => {
  switch (customEvent) {
    case 22006:
      if (parentInstanceSn) {
        serialNumber.value = parentInstanceSn
        recordType.value = subStringToType(parentInstanceSn)
        prescriptionId.value = recommandId
        theDetailVisible.value = true
        return
      }
      // R:线上处方  H:健康辅助方  HR:线下处方
      serialNumber.value = ''
      recordType.value = subStringToType('R')
      prescriptionId.value = recommandId
      theDetailVisible.value = true
      break
    default:
      break
  }
}
// 处理复诊提醒文案
const getRemindContent = remidData => {
  const { planEndDateForDA = '' } = remidData || {}
  let content = ''
  if (planEndDateForDA) {
    const time = moment(planEndDateForDA).format('MM月DD日')
    content = `系统将在${time}向您发送复诊提醒。`
  }
  return content
}
const checkboxChange = (item, index) => {
  const length = messageMap[activeKey.value]?.filter(m => m.checked)?.length
  // 最多只可选择多少条消息(且需要判断是否是取消勾选)
  if (length >= props.maxCheckedLength && !item.checked) {
    notification.error({
      message: `最多只可选择${props.maxCheckedLength}条消息哦！`
    })
    return
  }
  messageMap[activeKey.value][index].checked = !messageMap[activeKey.value][index].checked
  emit('checkboxChange', checkedMsgList.value)
}

const chooseRef = ref({})
const setChooseRef = groupId => el => {
  chooseRef[groupId] = el
}
// 选择以下消息
const chooseUnderMessage = () => {
  const chooseDom = chooseRef[activeKey.value]
  const messageListDom = messageListRefs[activeKey.value]
  const messageboxDom = messageboxRefs[activeKey.value]
  const childrens = messageListDom.children
  const offsetHeight = chooseDom.offsetHeight
  const scrollTop = messageboxDom.scrollTop - offsetHeight
  const result = Array.from(childrens)
    .filter(dom => {
      return dom.offsetTop > scrollTop && dom.getAttribute('data-canchecked') == 1
    })
    .slice(0, props.maxCheckedLength)
  messageMap[activeKey.value]?.forEach(msg => {
    msg.checked = false
  })
  emit('checkboxChange', checkedMsgList.value)
  result.forEach(dom => {
    const index = dom.getAttribute('data-index')
    messageMap[activeKey.value][index].checked = true
  })
  console.log(checkedMsgList, 'checkedMsgList')
  emit('checkboxChange', checkedMsgList.value)
}

// 图片预览是否可见
const setimageViewerVisible = status => {
  imageViewerVisible.value = status
  if (!status) previewImgId.value = undefined
}

//设置预览图片消息id
const setPreviewImgId = item => {
  previewImgId.value = item.msgId
  setimageViewerVisible(true)
}

// 查看治疗方案
const handleTreatmentPlan = prescriptionId => {
  theDetailVisible.value = true
  serialNumber.value = prescriptionId
  recordType.value = 'prescriptionGroup'
}

// 获取群聊图片列表
const getImgMsgUrls = async () => {
  if (!activeKey.value || activeKey.value === weComPatientChatId.value) return
  const result = (await getGroupImgMsgUrls({ groupId: activeKey.value })) || []
  srcList.value = result
}
watchEffect(() => {
  getImgMsgUrls()
})

// 判断时间是否显示
const getTimeVisible = (pre, cur) => {
  const preTime = pre.timestamp
  const curTime = cur.timestamp
  const showTime = curTime - preTime > 60000
  // 解决屏蔽的消息类型后面新消息不展示发送时间问题
  if (!showTime && Config.SHIELD_MSG.includes(`${pre.msgType}`)) {
    return true
  } else {
    return showTime
  }
}
const getGroupInfo = () => {
  if (activeKey.value === weComPatientChatId.value) return
  groupInfos({ groupIds: activeKey.value }).then((res = []) => {
    switch (activeKey.value) {
      case props.groupId:
        doctorName.value = res[0]?.ownerName || ''
        break
      case props.privateId:
        doctorName.value = res[0]?.doctorName || ''
        break
      default:
        doctorName.value = ''
        break
    }
    deepWorkOrderGroupInfo.value = res[0]
    // 当外部传入msgList时，这时需要获取群聊信息，但是不需要请求history接口
    if (!props.customList?.length && !messageMap[activeKey.value]?.length)
      nextTick(() => {
        getHistory()
      })
  })
}
//判断展示用户姓名
const renderName = id => {
  if (id === 'aiassistantadmin') return '智能医助'
  if (id === 'aiassistant') return '智能医助'
  if (RegExp(Config.SYSTEM_SOLE).test(id)) return '医生助手'
  const role = handleRole(id)
  const {
    bdInfos = [],
    daInfos = [],
    ownerName,
    patientName,
    groupType,
    dhInfos = []
  } = deepWorkOrderGroupInfo.value || {}
  //BD
  const aUserName = (bdInfos?.find(item => item.emUserId === id) || {}).username
  //医生助手
  const zUserName = (daInfos?.find(item => item.emUserId === id) || {}).username
  const hUserName = (dhInfos?.find(item => item.emUserId === id) || {}).username
  const pUserName = groupType === 2 ? ownerName : patientName
  const arr = [pUserName, aUserName, zUserName, ownerName, hUserName]
  return arr[role]
}

//判断展示头像
const renderHeader = id => {
  // if (RegExp(Config.SYSTEM_SOLE).test(id)) return head_z
  const { ownerHeadUrl, patientHeadUrl, groupType } = deepWorkOrderGroupInfo.value || {}
  const pHeaderUrl = (groupType === 2 ? ownerHeadUrl : patientHeadUrl) || head_p
  const dHeaderUrl = ownerHeadUrl || head_d
  const role = handleRole(id)
  const arr = [pHeaderUrl, head_a, head_z, dHeaderUrl, head_h, head_z, head_ai]
  return arr[role]
}
//默认头像
const renderDefaultHeader = id => {
  if (id === 'aiassistantadmin') return head_z
  if (RegExp(Config.SYSTEM_SOLE).test(id)) return head_z
  let headUrl = head_d
  if (!id) return head_z
  switch (id.substr(0, 1)) {
    case 'p':
      headUrl = head_p
      break
    case 'a':
      headUrl = head_a
      break
    case 'z':
      headUrl = head_z
      break
    case 'h':
      headUrl = head_h
      break
    default:
      break
  }
  return headUrl
}
//监听tab切换
watch(
  () => activeKey.value,
  newVal => {
    if (newVal === weComPatientChatId.value) return
    getGroupInfo()
    if (messageMap[newVal]?.length > 0) return
    if (newMsgTipsMap[newVal]) {
      newMsgTipsMap[newVal].page = 1
      newMsgTipsMap[newVal].loadText = '向上加载'
    }
    messageMap[newVal] = props.customList || []
  }
)

//撤回消息展示
const renderRecal = item => {
  if (item.from === chatId) return '你撤回了一条消息'
  return renderTitle(item.from) + '：' + renderName(item.from) + '撤回了一条消息'
}
const renderRecalByAI = item => {
  if (!item.operationUsers) return '系统撤回了一条消息'
  const Recals = item.operationUsers.find(v => v.operationType === 3)
  // 判断当前是不是自己撤回的记录
  const isMy = Recals.ucUserId === store.getters.userId && Recals.role === 4
  let text = ''
  if (isMy) {
    text = '你撤回了一条消息'
  } else {
    text = `${Recals.role === 3 ? 'BD' : '健管'}-${Recals.name}撤回了一条消息`
  }
  return text
}
watch(
  () => [props.guideConsultGroupId, props.groupId, props.privateId, props.doctorDaGroupId],
  newVal => {
    const [newGuideGroupId, newGroupId, newPrivateId, newDoctorDaGroupId] = newVal
    generateConversationList(newGroupId, newPrivateId, newGuideGroupId, newDoctorDaGroupId)
    activeKey.value = newGuideGroupId || newGroupId || newPrivateId || newDoctorDaGroupId
    if (newMsgTipsMap[activeKey.value]) {
      newMsgTipsMap[activeKey.value].page = 1
      newMsgTipsMap[activeKey.value].loadText = '向上加载'
    }
  },
  { immediate: true }
)

// 历史记录页仅在原会话具备患者私聊或问诊入口时初始化企微 Tab。
watch(
  () => [props.ucDoctorId, weComPatientId.value, props.groupId, props.privateId],
  async ([ucDoctorId, ucPatientId, groupId, privateId]) => {
    setWeComPatientChatVisible(false)
    resetWeComEligibility()
    if ((!groupId && !privateId) || !ucDoctorId || !ucPatientId) return
    const result = await checkWeComEligibility({ ucDoctorId, ucPatientId })
    if (result) setWeComPatientChatVisible(true)
  },
  { immediate: true }
)
// 系统消息的文案
const sysTitle = item => {
  const msg = item.bodies
  const { customEvent } = msg
  let text = Config.TIPS_MESSAGE_TYPE[customEvent]
  // 针对处方药材不足做出的消息调整
  if (customEvent === '22006' && msg.isInventoryMessageFlag) {
    text = msg.inventoryMessage || text
  }
  return text
}
//加载更多
const loadMoreMsgs = () => {
  const activeMsg = newMsgTipsMap[activeKey.value]
  if (!activeMsg) return
  // 尝试将 pageSize 转为数字
  const pageSize = Number(activeMsg.pageSize)
  // 检查 pageSize 的有效性
  if (isNaN(pageSize) || pageSize <= 0 || !Number.isInteger(pageSize)) {
    return Message.warning('加载的消息数量必须是一个大于 0 的整数')
  }
  if (pageSize > 100) {
    return Message.warning('最多只能加载 100 条历史消息')
  }
  if (activeMsg.showLoading) {
    return // 如果正在加载，则直接返回
  }
  const lastMsgMid = messageMap[activeKey.value]?.[0]?.msgId
  if (activeMsg.showLoading) return
  activeMsg.showLoading = true
  getHistory(lastMsgMid)
  //加载更多置顶
  nextTick(() => {
    messageboxRefs[activeKey.value].scrollTop = 0
  })
}

const needTraceMsg = ref(true)
const getHistory = async lastMsgMid => {
  const currentActiveKey = activeKey.value
  if (currentActiveKey === weComPatientChatId.value) return
  const params = {
    groupId: currentActiveKey,
    pageSize: newMsgTipsMap[currentActiveKey] && newMsgTipsMap[currentActiveKey].pageSize,
    page: 1,
    msgId: lastMsgMid
  }

  const traceSetPage = ref(null)
  if (needTraceMsg.value && props.msgTraceId) {
    try {
      const result = await getMsgIndex({
        groupId: currentActiveKey,
        msgId: props.msgTraceId
      })
      traceSetPage.value = customRound(result)
      params.pageSize = customRound(result)
    } catch (error) {
      //
    }
  }
  if (!currentActiveKey) return
  getHistoryByAssistant({ ...params }).then((res = {}) => {
    let { list = [] } = res
    list = list.map(v => {
      return {
        ...v,
        mid: v.msgId
      }
    })
    const newList = [...list, ...messageMap[currentActiveKey]]
    // 兼容帶有checkbox時需要默认勾选上已经被勾选中的数据
    if (props.showCheckbox && props.selectHistoryList?.length) {
      newList.forEach(newItem => {
        props.selectHistoryList.forEach(selectItem => {
          if (selectItem.msgId === newItem.msgId || selectItem === newItem.msgId)
            newItem.checked = true
        })
      })
    }
    // 构造已读人员
    newList.forEach(element => {
      const { readers } = element
      const isByself = element.from === store.getters.chatId
      const readRoles =
        readers && readers.length
          ? readers.map(item => {
              if (isByself ? item.emUserId !== store.getters.chatId : true) {
                return item.emUserId
              }
            })
          : []
      element.readRoles = readRoles
      element.bySelf = isByself
    })
    messageMap[currentActiveKey] = newList
    newMsgTipsMap[currentActiveKey].showLoading = false
    // 从跟踪消息的下一页开始查
    if (needTraceMsg.value && props.msgTraceId) {
      newMsgTipsMap[currentActiveKey].page = traceSetPage.value / 10 + 1
    } else {
      newMsgTipsMap[currentActiveKey].page = newMsgTipsMap[currentActiveKey].page + 1
    }
    if (!res.hasNext) {
      return (newMsgTipsMap[currentActiveKey].loadText = '')
    }
    nextTick(() => {
      if (needTraceMsg.value && props.msgTraceId) {
        scrollToMid(props.msgTraceId)
      } else {
        !lastMsgMid && scrollBottom()
      }
      messageboxRefs[currentActiveKey]?.addEventListener('scroll', getScrollHeight)
      needTraceMsg.value = false
    })
  })
}
//跳转底部
const scrollToMid = mid => {
  if (!messageMap[activeKey.value]?.length) return
  const curRollItem = document.getElementById(mid)
  curRollItem.scrollIntoView({ block: 'start', behavior: 'auto' })
}
//文字渲染 换行
const renderTxt = (txt = '') => {
  return replaceEmojiCodesWithImages(txt.trim().replace(/\n|\\n/g, '<br>'))
}

const customRound = num => {
  const remainder = num % 10
  if (remainder >= 1) {
    return Math.ceil(num / 10) * 10
  } else {
    return Math.floor(num / 10) * 10
  }
}

// 查看绑定的医生
const bindDetailInfoRef = ref(null)
const bindAssistentRef = ref(null)
const seeBindDetail = (ctx, type) => {
  console.log('ctx', ctx)
  const id = type === 'doctor' ? ctx.ucDoctorId : ctx.bdUcUserId
  if (type === 'doctor') {
    const { ucDoctorId, doctorId } = ctx
    const detailParams = {
      ucDoctorId,
      doctorId
    }
    bindDetailInfoRef.value.initModal(detailParams, type)
  } else {
    bindAssistentRef.value.initModal(id, type)
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';

.message-bottom-tips {
  background-color: #1a1a1a08;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  color: #5c5c5c;
  display: inline-block;

  .message-tips-text {
    color: #3f64ff;
    cursor: pointer;
  }
}
</style>
